<template>
    <div class="area-bottom">
        <div class="bottom-bar">
            <div class="col-md-6">
                Copyright © 2020 BHPetrol. All Rights Reserved.
            </div>
            <div class="col-md-6">
                <a
                    href="http://www.bhpetrol.com.my/about-us/the-story-of-bhpetrol"
                    target="_blank"
                    >About Us</a
                >
                |
                <a
                    href="http://www.bhpetrol.com.my/contact/contact-us"
                    target="_blank"
                    >Contact Us</a
                >
                |
                <a
                    href="http://www.bhpetrol.com.my/products-services/cards-services/bhpetrol-ecard/overview-2020"
                    target="_blank"
                    >Terms & Conditions</a
                >
                |
                <a
                    href="http://www.bhpetrol.com.my/disclaimer/privacy-policy"
                    target="_blank"
                    >Privacy Policy</a
                >
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BottomBar"
};
</script>

<style lang="scss" scoped>
@import "./BottomBar.scss";
</style>
